export function fitFavoriteCount(widths: number[], availableWidth: number, moreWidth: number, gap = 2): number {
  const total = widths.reduce((sum, width) => sum + width, 0) + Math.max(0, widths.length - 1) * gap;
  if (total <= availableWidth) return widths.length;
  let used = 0;
  let count = 0;
  for (const width of widths) {
    if (used + width + gap + moreWidth > availableWidth) break;
    used += width + gap;
    count++;
  }
  return count;
}
